:host {
  .item-news {
    border-top: 1px solid var(--divider);
    padding: 24px 16px 16px;
    &.unseen-news {
      background-color: var(--bg-secondary-hover);
    }
    &.pointer {
      cursor: pointer;
    }
    &.pinned-news {
      background-color: var(--bg-blue-manager);
      margin: 24px 16px 16px;
      border-radius: 8px;
    }

    &__info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .label {
        font-size: 12px;
        font-weight: 500;
        color: #85a2b6;
      }
      .state-icon {
        width: 8px;
        height: 8px;
        background: var(--blue);
        border-radius: 50%;
      }
    }

    &__title {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin-bottom: 16px;
      white-space: normal;
      .service-icon {
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          background-color: var(--bg-block);
          &.unseen-news {
            background-color: var(--bg-primary);
          }
          img {
            width: 17px;
          }
        }
      }
      .text {
        font-size: 14px;
        font-weight: 500;
        color: var(--font-primary);
      }
    }

    &__content {
      white-space: pre-wrap;
      font-size: 14px;
      font-weight: 400;
      color: var(--font-secondary);
      a {
        text-decoration: none;
        color: var(--blue-link);
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &__link {
      margin-top: 8px;
      span {
        color: var(--blue-link);
        font-size: 14px;
        font-weight: 400;
      }
    }

    &__image {
      margin-top: 16px;
      img {
        width: 100%;
        border-radius: 4px;
      }
    }

    &__vod {
      width: 100%;
      height: 220px;
      margin-top: 16px;
      border-radius: 4px;
      &--square {
        height: auto;
        aspect-ratio: 1 / 1;
      }
    }

    &__date {
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      .left-date,
      .right-date {
        font-size: 11px;
        font-weight: 400;
        color: var(--font-secondary);
      }
      .bullet {
        width: 4px;
        height: 4px;
        background: #d9d9d9;
        border-radius: 100px;
      }
    }
  }
}
